/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminServiceUpdateStagedAltArtRequest } from '../../models/admin-service-update-staged-alt-art-request';
import { UpdateStagedAltArtResponse } from '../../models/update-staged-alt-art-response';

export interface AdminServiceUpdateStagedAltArt$Params {
  gachaId: string;
  altArtId: number;
      body: AdminServiceUpdateStagedAltArtRequest
}

export function adminServiceUpdateStagedAltArt(http: HttpClient, rootUrl: string, params: AdminServiceUpdateStagedAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateStagedAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceUpdateStagedAltArt.PATH, 'put');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateStagedAltArtResponse>;
    })
  );
}

adminServiceUpdateStagedAltArt.PATH = '/api/v3/gateway/admin/stage/alt_art/{gachaId}/{altArtId}';
